import {styled} from '@customink/pigment-react/lib/themeCustomink';

const ProductCardTitle = styled('a', {
  shouldForwardProp: (prop) => prop !== 'compact'
})(({compact = false}) => ({
  color: '#000000db !important',
  display: 'inline',
  fontSize: '0.875rem',
  fontWeight: 'bold !important',
  lineHeight: '1.25',
  marginBottom: '-0.15em',
  marginTop: compact ? 'unset' : '-0.155em',
  textDecoration: 'none'
}));

export default ProductCardTitle;
